<template>
  <div v-if="visivel" class="ida-overlay" @click.self="fechar">
    <div class="ida-modal">

      <!-- Cabeçalho -->
      <div class="ida-modal__header">
        <div>
          <h4 class="ida-modal__title">
            <i class="fas fa-percent mr-2"></i>Desconto / Acréscimo do item
          </h4>
          <small class="ida-modal__subtitle" v-if="item">
            {{ item.descricao }}
          </small>
        </div>
        <button class="ida-btn ida-btn--light" @click="fechar">✕</button>
      </div>

      <!-- Corpo -->
      <div class="ida-modal__body">

        <!-- Card resumo do item -->
        <div v-if="item" class="ida-item-card">
          <div class="ida-item-card__row">
            <span class="ida-item-card__label">Produto</span>
            <span class="ida-item-card__value">{{ item.descricao }}</span>
          </div>
          <div class="ida-item-card__row">
            <span class="ida-item-card__label">Quantidade</span>
            <span class="ida-item-card__value">{{ Number(item.quantidade).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 3 }) }}</span>
          </div>
          <div class="ida-item-card__row">
            <span class="ida-item-card__label">Valor unitário</span>
            <span class="ida-item-card__value">{{ fmtBRL(item.valor_unitario) }}</span>
          </div>
          <div class="ida-item-card__row ida-item-card__row--total">
            <span class="ida-item-card__label">Total bruto</span>
            <span class="ida-item-card__value">{{ fmtBRL(totalBruto) }}</span>
          </div>
        </div>

        <!-- Tipo de ajuste -->
        <div class="ida-form-group">
          <label class="ida-label">Tipo de ajuste</label>
          <div class="ida-tabs">
            <button
              type="button"
              :class="['ida-tab', { 'ida-tab--active': form.tipo === 'desconto' }]"
              @click="form.tipo = 'desconto'"
            >
              <i class="fas fa-minus-circle mr-1"></i> Desconto
            </button>
            <button
              type="button"
              :class="['ida-tab', { 'ida-tab--active': form.tipo === 'acrescimo' }]"
              @click="form.tipo = 'acrescimo'"
            >
              <i class="fas fa-plus-circle mr-1"></i> Acréscimo
            </button>
          </div>
        </div>

        <!-- Forma do ajuste -->
        <div class="ida-form-group">
          <label class="ida-label">Forma</label>
          <div class="ida-tabs">
            <button
              type="button"
              :class="['ida-tab', 'ida-tab--small', { 'ida-tab--active': form.forma === 'percentual' }]"
              @click="form.forma = 'percentual'"
            >
              <i class="fas fa-percent mr-1"></i> Percentual
            </button>
            <button
              type="button"
              :class="['ida-tab', 'ida-tab--small', { 'ida-tab--active': form.forma === 'valor' }]"
              @click="form.forma = 'valor'"
            >
              R$ Valor
            </button>
          </div>
        </div>

        <!-- Valor do ajuste -->
        <div class="ida-form-group">
          <label class="ida-label">
            {{ form.forma === 'percentual' ? 'Percentual do ajuste' : 'Valor do ajuste' }}
          </label>
          <div class="ida-input-wrap">
            <input
              ref="valorInput"
              v-model.number="form.valor"
              type="number"
              :step="form.forma === 'percentual' ? '0.01' : '0.01'"
              min="0"
              class="ida-input"
              :class="{ 'ida-input--erro': erro }"
              :placeholder="form.forma === 'percentual' ? '0,00' : '0,00'"
              @keydown.enter.prevent="aplicar"
              @focus="$event.target.select()"
            />
            <span class="ida-input-suffix">{{ form.forma === 'percentual' ? '%' : 'R$' }}</span>
          </div>
          <small v-if="erro" class="ida-erro-msg">{{ erro }}</small>
        </div>

        <!-- Prévia -->
        <div class="ida-preview">
          <div class="ida-preview__row">
            <span class="ida-preview__label">Desconto</span>
            <span class="ida-preview__value ida-preview__value--desc">{{ fmtBRL(previewDesconto) }}</span>
          </div>
          <div class="ida-preview__row">
            <span class="ida-preview__label">Acréscimo</span>
            <span class="ida-preview__value ida-preview__value--acres">{{ fmtBRL(previewAcrescimo) }}</span>
          </div>
          <div class="ida-preview__row ida-preview__row--total">
            <span class="ida-preview__label">Total final do item</span>
            <span class="ida-preview__value ida-preview__value--total">{{ fmtBRL(previewTotal) }}</span>
          </div>
        </div>
      </div>

      <!-- Rodapé -->
      <div class="ida-modal__footer">
        <button
          v-if="temAjuste"
          class="ida-btn ida-btn--warning"
          @click="removerAjuste"
        >
          <i class="fas fa-eraser mr-1"></i> Remover ajuste
        </button>
        <div class="ida-modal__footer-right">
          <button class="ida-btn ida-btn--light" @click="fechar">Cancelar</button>
          <button class="ida-btn ida-btn--primary" @click="aplicar">
            <i class="fas fa-check mr-1"></i> Aplicar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemDescontoAcrescimoModal",

  props: {
    visivel: { type: Boolean, default: false },
    item:    { type: Object,  default: null },
  },

  data() {
    return {
      form: {
        tipo:  "desconto",   // 'desconto' | 'acrescimo'
        forma: "percentual", // 'percentual' | 'valor'
        valor: 0,
      },
      erro: "",
    };
  },

  computed: {
    totalBruto() {
      if (!this.item) return 0;
      const q = Number(this.item.quantidade) || 0;
      const u = Number(this.item.valor_unitario) || 0;
      return this._round(q * u);
    },

    _valorDescontoCalc() {
      if (this.form.tipo !== "desconto") return 0;
      const v = Number(this.form.valor) || 0;
      if (v <= 0) return 0;
      if (this.form.forma === "percentual") {
        return this._round((this.totalBruto * v) / 100);
      }
      return this._round(v);
    },

    _valorAcrescimoCalc() {
      if (this.form.tipo !== "acrescimo") return 0;
      const v = Number(this.form.valor) || 0;
      if (v <= 0) return 0;
      if (this.form.forma === "percentual") {
        return this._round((this.totalBruto * v) / 100);
      }
      return this._round(v);
    },

    previewDesconto() { return this._valorDescontoCalc; },
    previewAcrescimo() { return this._valorAcrescimoCalc; },

    previewTotal() {
      return this._round(this.totalBruto - this.previewDesconto + this.previewAcrescimo);
    },

    temAjuste() {
      if (!this.item) return false;
      return (
        Number(this.item.desconto_valor || this.item.desconto || 0) > 0 ||
        Number(this.item.acrescimo_valor || this.item.acrescimo || 0) > 0
      );
    },
  },

  watch: {
    visivel(novo) {
      if (novo) this._inicializarForm();
    },
  },

  methods: {
    fmtBRL(val) {
      return Number(val || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    _round(n) {
      return Math.round(Number(n || 0) * 100) / 100;
    },

    _inicializarForm() {
      this.erro = "";
      const item = this.item || {};

      const tipoAtual  = item.ajuste_tipo  || null;
      const formaAtual = item.ajuste_forma || null;

      if (tipoAtual === "desconto") {
        this.form.tipo  = "desconto";
        this.form.forma = formaAtual === "valor" ? "valor" : "percentual";
        this.form.valor = this.form.forma === "valor"
          ? Number(item.desconto_valor      || item.desconto || 0)
          : Number(item.desconto_percentual || 0);
      } else if (tipoAtual === "acrescimo") {
        this.form.tipo  = "acrescimo";
        this.form.forma = formaAtual === "valor" ? "valor" : "percentual";
        this.form.valor = this.form.forma === "valor"
          ? Number(item.acrescimo_valor      || item.acrescimo || 0)
          : Number(item.acrescimo_percentual || 0);
      } else {
        this.form.tipo  = "desconto";
        this.form.forma = "percentual";
        this.form.valor = 0;
      }

      this.$nextTick(() => {
        if (this.$refs.valorInput) {
          this.$refs.valorInput.focus();
          this.$refs.valorInput.select();
        }
      });
    },

    aplicar() {
      const valor = Number(this.form.valor) || 0;

      if (valor < 0) {
        this.erro = "Informe um valor válido para o ajuste.";
        return;
      }

      if (valor === 0) {
        // Aplicar zero = remover ajuste
        this.removerAjuste();
        return;
      }

      // Validações de percentual
      if (this.form.forma === "percentual") {
        if (this.form.tipo === "desconto" && valor > 100) {
          this.erro = "Percentual de desconto não pode ser maior que 100%.";
          return;
        }
      }

      // Calcula valores efetivos
      const descontoValor  = this._valorDescontoCalc;
      const acrescimoValor = this._valorAcrescimoCalc;

      // Desconto não pode ultrapassar o total bruto
      if (this.form.tipo === "desconto" && descontoValor > this.totalBruto) {
        this.erro = "O desconto não pode ser maior que o total do item.";
        return;
      }

      this.erro = "";

      const percentual = this.form.forma === "percentual"
        ? this._round(valor)
        : (this.totalBruto > 0
            ? this._round(((this.form.tipo === "desconto" ? descontoValor : acrescimoValor) / this.totalBruto) * 100)
            : 0);

      this.$emit("aplicar", {
        ajuste_tipo:           this.form.tipo,
        ajuste_forma:          this.form.forma,
        desconto_valor:        this.form.tipo === "desconto"  ? descontoValor  : 0,
        desconto_percentual:   this.form.tipo === "desconto"  ? percentual     : 0,
        acrescimo_valor:       this.form.tipo === "acrescimo" ? acrescimoValor : 0,
        acrescimo_percentual:  this.form.tipo === "acrescimo" ? percentual     : 0,
      });
    },

    removerAjuste() {
      this.erro = "";
      this.$emit("aplicar", {
        ajuste_tipo:          null,
        ajuste_forma:         null,
        desconto_valor:       0,
        desconto_percentual:  0,
        acrescimo_valor:      0,
        acrescimo_percentual: 0,
      });
    },

    fechar() {
      this.erro = "";
      this.$emit("fechar");
    },
  },
};
</script>

<style scoped>
.ida-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.ida-modal {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22);
  width: 480px;
  max-width: 96vw;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ida-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1.3rem 0.8rem;
  border-bottom: 1px solid #dee2e6;
  background: #eef5ff;
}

.ida-modal__title {
  font-size: 15px;
  font-weight: 700;
  margin: 0 0 2px;
  color: #212529;
}

.ida-modal__subtitle {
  color: #6c757d;
  font-size: 14px;
}

.ida-modal__body {
  padding: 1rem 1.3rem;
  overflow-y: auto;
  flex: 1;
}

.ida-modal__footer {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1.3rem;
  border-top: 1px solid #dee2e6;
  background: #f8f9fa;
}

.ida-modal__footer-right {
  display: flex;
  gap: 0.5rem;
  margin-left: auto;
}

.ida-item-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 0.7rem 0.9rem;
  margin-bottom: 1rem;
}

.ida-item-card__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 2px 0;
}

.ida-item-card__row--total {
  margin-top: 0.4rem;
  padding-top: 0.4rem;
  border-top: 1px dashed #dee2e6;
  font-weight: 700;
}

.ida-item-card__label {
  color: #6c757d;
}

.ida-item-card__value {
  color: #212529;
  font-weight: 600;
}

.ida-form-group {
  margin-bottom: 0.9rem;
}

.ida-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.ida-tabs {
  display: flex;
  gap: 0.4rem;
}

.ida-tab {
  flex: 1;
  padding: 0.55rem 0.7rem;
  border: 1px solid #ced4da;
  background: #fff;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  color: #495057;
  transition: all 0.15s ease;
}

.ida-tab--small {
  padding: 0.45rem 0.6rem;
  font-size: 14px;
}

.ida-tab:hover {
  background: #f8f9fa;
}

.ida-tab--active {
  background: var(--primary-color, #ee7361);
  border-color: var(--primary-color, #ee7361);
  color: #fff;
}

.ida-input-wrap {
  position: relative;
}

.ida-input {
  width: 100%;
  padding: 0.55rem 2.2rem 0.55rem 0.7rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  text-align: right;
}

.ida-input:focus {
  outline: none;
  border-color: var(--primary-color, #ee7361);
  box-shadow: 0 0 0 2px rgba(238, 115, 97, 0.15);
}

.ida-input--erro {
  border-color: #dc3545;
}

.ida-input-suffix {
  position: absolute;
  right: 0.7rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 14px;
  font-weight: 700;
}

.ida-erro-msg {
  display: block;
  color: #dc3545;
  font-size: 12px;
  margin-top: 0.25rem;
}

.ida-preview {
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  padding: 0.7rem 0.9rem;
  margin-top: 0.5rem;
}

.ida-preview__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 2px 0;
}

.ida-preview__row--total {
  margin-top: 0.4rem;
  padding-top: 0.4rem;
  border-top: 1px dashed #ffcc80;
  font-size: 15px;
  font-weight: 700;
}

.ida-preview__label {
  color: #6c757d;
}

.ida-preview__value {
  font-weight: 700;
  color: #212529;
}

.ida-preview__value--desc {
  color: #dc3545;
}

.ida-preview__value--acres {
  color: #198754;
}

.ida-preview__value--total {
  color: var(--primary-color, #ee7361);
  font-size: 17px;
}

.ida-btn {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.ida-btn--light {
  background: #fff;
  border-color: #ced4da;
  color: #495057;
}

.ida-btn--light:hover { background: #f8f9fa; }

.ida-btn--primary {
  background: var(--primary-color, #ee7361);
  border-color: var(--primary-color, #ee7361);
  color: #fff;
}

.ida-btn--primary:hover { background: #e05a47; }

.ida-btn--warning {
  background: #fff3cd;
  border-color: #ffe082;
  color: #856404;
}

.ida-btn--warning:hover { background: #ffeeba; }
</style>
